export default __webpack_public_path__ + "static/media/saute-skiver-gris.5068ce35.jpg";